"use client";

import Link from "next/link";
import { FC } from "react";
import Image from "next/image";
import { toAssetImages } from "src/lib/utils";

interface SalifyHeaderLogoWrapperProps {
  logoUrl?: string;
  logoWidth?: number;
  logoHeight?: number;
}

export const SalifyHeaderLogoWrapper: FC<SalifyHeaderLogoWrapperProps> = (props) => {
  return props.logoUrl ? (
    <Link
      href="/"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        padding: "10px 16px",
        marginRight: "8px",
      }}
    >
      <Image
        src={toAssetImages(props.logoUrl)}
        alt=""
        width={props?.logoWidth ?? 240}
        height={props?.logoHeight ?? 54}
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain",
          display: "block",
        }}
      />
    </Link>
  ) : null;
};

SalifyHeaderLogoWrapper.displayName = "SalifyHeaderLogoWrapper";
